import { createSelector } from 'reselect';
import { RootState } from 'services/store';

export const selectSlice = (state: RootState) => state.vehicles;

export const selectVehicles = createSelector(selectSlice, (slice) => slice.vehicles);
export const selectDefaultVehicle = createSelector(selectSlice, (slice) => slice.defaultVehicle);
